/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { colors } from "./colors";
import { effects } from "./effects";
import { PlaceholderBody } from "./PlaceholderBody";

export const placeholderButtonStyle = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  background: ${colors.buttonPrimaryWhite};
  box-shadow: ${effects.buttonPrimary};
  border: none;
  border-radius: 8px;
  width: 100%;
  padding: 24px;
  cursor: pointer;
  &:hover {
    background: ${colors.whiteHover};
  }
`;

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  header: string;
  subHeader: string;
  type: "button" | "submit" | "reset";
}

export const PlaceholderButton = ({
  icon,
  header,
  subHeader,
  type,
  ...rest
}: Props) => {
  return (
    <button css={placeholderButtonStyle} type={type} {...rest}>
      <PlaceholderBody icon={icon} header={header} subHeader={subHeader} />
    </button>
  );
};
